<template>
	<div style="padding: 20px">
		<v-flex>
			<v-layout align-end justify-end mr-3 class="no-print">
				<v-btn align-end justify-end @click="print">Wydrukuj</v-btn>
				<v-btn align-end justify-end @click="generateExport">Eksportuj koszty</v-btn>
			</v-layout>
		</v-flex>

		<div v-if="editLocked">
			<agency-final-report-header
				:project-title="readOnlyData.projectTitle"
				:project-code="readOnlyData.projectCode"
				:control-sum="readOnlyData.controlSum"
				:agency-name="readOnlyData.agencyName"
				:partner-name="filledData.partnerName"
				:project-start-date="filledData.projectStartDate"
				:project-end-date="filledData.projectEndDate"
				:minister-donation="readOnlyData.ministerDonation"
				:approved-donation="readOnlyData.approvedDonation"
				:send-date="sendDate"
				:approval-date="approvalDate"
				:currency="readOnlyData.currencyCode"
				:show-approved-header="metadata.status === 'APPROVED'"
			/>
		</div>
		<div v-else>
			<h1 class="mb-3">Sprawozdanie końcowe</h1>
			<div class="mb-2">
				<h3 style="display: inline">
					Nazwa projektu:
				</h3> <span style="font-size: 16px" class="ml-2"> {{ readOnlyData.projectTitle }} </span><br>
			</div>

			<div class="mb-2">
				<h3 style="display: inline">
					Numer projektu:
				</h3> <span style="font-size: 16px" class="ml-2">{{ readOnlyData.projectCode }} </span><br>
			</div>

			<div class="mb-2">
				<h3 style="display: inline">
					Nazwa placówki:
				</h3> <span style="font-size: 16px" class="ml-2"> {{ readOnlyData.agencyName }} </span><br>
			</div>

			<v-form ref="headerForm">
				<div class="mb-2">
					<v-layout row wrap align-center>
						<h3>Nazwa instytucji partnerskiej / wykonawcy: <span style="color: red">*</span></h3>
						<v-flex xs4>
							<v-text-field
								browser-autocomplete="off"
								:disabled="editLocked"
								:required="true"
								:rules="[requiredRule]"
								class="ml-3"
								v-model="filledData.partnerName"
								aria-label="partner name">
							</v-text-field>
						</v-flex>
					</v-layout>
				</div>

				<div class="mb-2">
					<h3 style="display: inline">
						Okres realizacji projektu: <span style="color: red">*</span>
					</h3>
					<v-layout row>
						<egranty-date-picker
							:disabled="editLocked"
							:required="true"
							v-model="filledData.projectStartDate"
							label="Początek"
						/>
						<egranty-date-picker
							:disabled="editLocked"
							:required="true"
							v-model="filledData.projectEndDate"
							label="Koniec"
						/>
					</v-layout>
				</div>
			</v-form>
		</div>

		<v-divider class="ma-4"/>

		<div class="mt-3 mb-3" v-if="configuration.form">
			<h2 style="margin-left: 20px">{{ configuration.form.sections[0].name }} </h2>
			<vue-form-generator
				:disabled="editLocked"
				name="generator"
				ref="vfg"
				:model="reportData.model"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<v-divider class="ma-4"/>

		<h3>Sprawozdanie finansowe</h3>


		<v-layout row wrap>
			<v-flex d-flex xs12>
				<v-card color="grey darken-1">
					<v-card-text>
						<v-layout>
							<strong>
								SPRAWOZDANIE FINANSOWE Z REALIZACJI PROJEKTU {{ readOnlyData.projectCode }}
								<v-btn v-if="!editLocked" @click="addCost">
									Dodaj koszt
								</v-btn>
							</strong>
						</v-layout>
						<v-layout>

							<strong>
								<v-flex>Kwota przyznana z MSZ: {{
									formatMoney(readOnlyData.totalMSZFunding) + " " +
										readOnlyData.currencyCode
								}}
								</v-flex>
								<v-flex>Środki ogółem: {{
									formatMoney(readOnlyData.totalFunding) + " " +
										readOnlyData.currencyCode
								}}
								</v-flex>

							</strong>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>


		<v-layout row wrap>
			<v-flex d-flex xs3>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Rodzaj płatności
						</strong>
						<div style="font-size: 11px">
							Należy wymienić wszystkie płatności dokonywane w trakcie realizacji projektu w zależności od
							konstrukcji  umowy płatność za etapy bądź płatność za całość po wykonaniu umowy
							(np. płatność za I etap realizacji umowy nr… z dn.. ).
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs4>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Opis wydatków
						</strong>
						<div style="font-size: 11px">
							Należy wskazać cel poniesienia wydatku np. wyposażenie sali komputerowej w 10 laptopów,
							przeprowadzenie szkoleń z przedsiębiorczości dla 20 studentów, zainstalowanie 15 paneli słonecznych
							w 10 szkołach, wymiana dachu w domu dziecka.
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs3>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Data płatności
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-0">
					<v-card-text>
						<strong>
							Kwota ({{ readOnlyData.currencyCode }})
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-form ref="form" class="project-final-report-table">
			<v-layout row wrap v-for="(cost,index) in filledData.costs" :key="index">
				<v-flex d-flex xs3>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 0">
							<egranty-text-input-field
								v-if="!printing"
								:disabled="editLocked"
								label="Rodzaj płatności"
								v-model="cost.costType"
								:textarea="true"
								:auto-grow="true"
							/>
							<div v-if="printing" style="padding: 20px">
								{{ cost.costType }}
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 0">
							<egranty-text-input-field
								v-if="!printing"
								:disabled="editLocked"
								label="Opis wydatków"
								v-model="cost.description"
								:textarea="true"
								:auto-grow="true"
							/>
							<div v-if="printing" style="padding: 20px">
								{{ cost.description }}
							</div>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 10px">
							<egranty-date-picker
								:disabled="editLocked"
								:required="true"
								label="Data płatności"
								v-model="cost.paymentDate"
							/>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 10px">
							<egranty-number-input-field
								:disabled="editLocked"
								:label="'Kwota (' + readOnlyData.currencyCode + ')'"
								v-model="cost.value"
								:suffix="readOnlyData.currencyCode"
							/>
							<egranty-icon-button
								v-if="!editLocked"
								label="Usuń ten koszt"
								color="lightred"
								icon="delete"
								@click="() => deleteCost(index)"
							/>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>
		<v-form ref="form2">
			<v-layout row wrap>
				<v-flex d-flex xs10>
					<v-card color="grey darken-0">
						<v-card-text>
							<strong>
								Ogółem
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 10px; padding-left: 10px; text-align: right">
							<strong v-if="filledData.costs">
								{{formatMoney(filledData.costs.map(cost => parseToFloat(cost.value)).reduce((a, b) => a
									+ b, 0))}} {{readOnlyData.currencyCode}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>

		<div class="ma-5 signature">
			<v-layout row>
				<table style="width:100%; border: 1px solid black; border-collapse: collapse">
					<tr style="height: 35px; border: 1px solid black">
						<th class="ma-2"
							style="padding: 5px; font-size: 14px; width: 50%; text-align: center; border: 1px solid black">
							Podpis pracownika placówki wyznaczonego do realizacji projektu
						</th>
						<th style="padding: 5px; font-size: 14px; width: 50%; text-align: center; border: 1px solid black">
							Podpis kierownika placówki lub osoby pełniącej funkcję zastępcy kierownika placówki
						</th>
					</tr>
					<tr style="height: 60px">
						<td style="border: 1px solid black"></td>
						<td style="border: 1px solid black"></td>
					</tr>
				</table>

			</v-layout>
		</div>

		<v-btn
			v-if="!editLocked"
			@click="sendReport"
			color="success"
			class="no-print">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>

		<v-btn @click="saveReport"
			v-if="!editLocked"
			color="info"
			class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz raport
		</v-btn>

		<agency-project-final-report-confirmation-dialog
			:action="send"
			:dialog-model="viewData.sendReportDialog"
			@close-confirmation="viewData.sendReportDialog = false"
			:loading="loading"
		/>

		<egranty-validation-error
			v-for="(error) in errors"
			:key="error"
			:error="error"
		/>

	</div>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {AgencyFinalReport} from "@/api/generated/AgencyFinalReport";
	import AgencyProjectFinalReportConfirmationDialog from "./components/AgencyProjectFinalReportConfirmationDialog";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
	import EgrantyTextInputField from "../../../genericComponents/EgrantyTextInputField";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import EgrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import {Numbers} from "@/utils/Numbers";
	import AgencyFinalReportHeader from "./components/AgencyFinalReportHeader";
	import {Files} from "@/utils/Files";
	import {AgencyFinalReportCostExporter} from "@/view/logged/agencyProject/utils/AgencyFinalReportCostExporter";
	import {Dates} from "@/utils/Dates";

	export default {
		name: "AgencyProjectFinalReportForm",
		components: {
			AgencyFinalReportHeader,
			EgrantyValidationError,
			EgrantyIconButton,
			EgrantyTextInputField,
			EgrantyDatePicker,
			AgencyProjectFinalReportConfirmationDialog,
			EgrantyNumberInputField,
		},
		mixins: [Numbers],
		watch: {
			"reportData.model": {
				handler() {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true,
			},
		},

		computed: {

			editLocked() {
				return this.readOnly || !(this.metadata.status === "NEW" || this.metadata.status === "REQUESTED_CHANGES") || this.printing;
			},
		},

		data() {
			return {
				errors: [],
				metadata: {},

				configuration: {
					form: "",
				},

				reportData: {
					model: undefined,
				},

				viewData: {
					sendReportDialog: false,
				},

				projectId: this.$route.params.projectId,

				agencyContestId: this.$route.params.id,

				filledData: {},

				readOnlyData: {},

				sendDate: "",

				approvalDate: "",

				printing: false,

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},
				loading: false,
			};
		},

		created() {
			this.loadData();
		},

		methods: {

			requiredRule(value) {
				return !value ? "To pole jest wymagane." : true;
			},

			validate() {
				this.errors = [];
				if (!this.filledData.partnerName) {
					this.errors.push("Proszę uzupełnić nazwę partnera");
				}
				if (!this.filledData.projectStartDate) {
					this.errors.push("Proszę uzupełnić datę początku projektu");
				}
				if (!this.filledData.projectEndDate) {
					this.errors.push("Proszę uzupełnić datę końca projektu");
				}

				return this.errors.length === 0;
			},
      
			generateExport() {
				let requestBody = AgencyFinalReportCostExporter.generate(this.readOnlyData, this.filledData.costs);
				AgencyFinalReport.postExportCosts(this, requestBody, successResponse => {
						let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + "_raport.xlsx";
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
						Files.methods.downloadBlobResponse(successResponse, filename);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob"
					});
			},


			emptyCost() {
				return {
					costType: "",
					description: "",
					paymentDate: null,
					value: null,
				};
			},

			deleteCost(index) {
				this.filledData.costs.splice(index, 1);
			},

			addCost() {
				this.filledData.costs.push(this.emptyCost());
			},

			async loadData() {

				AgencyFinalReport.getConfiguration(this, this.agencyContestId, this.loadConfigurationAndFilledData);

				AgencyFinalReport.getReadOnlyData(this, this.projectId, (response) => this.readOnlyData = response);

				AgencyFinalReport.getCurrentState(this, this.projectId, (response) => this.metadata = response);

				AgencyFinalReport.getSendAndApprovalDates(this, this.projectId, success => {
					this.sendDate = success.sendDate;
					this.approvalDate = success.approvalDate;
				});
			},

			loadConfigurationAndFilledData(configuration) {
				this.configuration.form = genericFormUtil.decodeSchema(configuration.schema);

        if (!this.configuration.form) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);
				AgencyFinalReport.getFilledData(this, this.projectId, success => {
					this.filledData = success;
					if (success.filledForm === null) {
						this.reportData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.reportData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});
			},

			saveReport() {
				AgencyFinalReport.postData(this, this.projectId, this.filledData, successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano raport", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać raportu", errorResponse);
				});
			},

			async sendReport () {
				let validationPromise = await this.$refs.vfg.validate();
				let headerValid = this.validate();
				let headerFieldsValid = this.$refs.headerForm.validate();
				let costsValid = this.$refs.form.validate();
				if (validationPromise.length > 0 || !headerValid || !headerFieldsValid || !costsValid) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane raportu!");
					return;
				}
				this.viewData.sendReportDialog = true;
			},

			async send() {
				if(!this.loading){
				this.loading = true;
				let validationPromise = await this.$refs.vfg.validate();
				let headerValid = this.validate();
				let headerFieldsValid = this.$refs.headerForm.validate();
				let costsValid = this.$refs.form.validate();
				if (validationPromise.length > 0 || !headerValid || !headerFieldsValid || !costsValid) {
					this.viewData.sendReportDialog = false;
					this.loading = false;
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane raportu!");
					return;
				}
				AgencyFinalReport.postSaveAndSubmit(this,
					this.projectId,
					this.filledData,
					successResponse => {
						this.viewData.sendReportDialog = false;
						this.loading = false;
						this.$messagesBus.$emit("success", "Raport został wysłany!", successResponse);
						this.loadData();
					}, errorResponse => {
						this.viewData.sendReportDialog = false;
						this.loading = false;
						this.$messagesBus.$emit("error", "Nie udało się wysłać raportu", errorResponse);
					});
				}
			},

			applyGenericForm(form) {
				this.filledData.filledForm = genericFormUtil.encodeSchema(this.reportData.model);

        if (!form) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.editLocked);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.reportData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getAgencyProjectFinalReportPrintUrl(
						this.agencyContestId,
						this.projectId,
					),
					"sprawozdanie_końcowe.pdf"
				);
			},
		},

		props: {
			readOnly: {},
		},
	};
</script>

<style scoped>
.project-final-report-table .v-card {
	width: 100%;
}
</style>
